import AppDispatcher from '../dispatcher/AppDispatcher'
import TransportConstants from '../constants/TransportConstants'
import TransportAPI from '../utils/TransportAPI'

export default {

  recieveMonths: (pid) => {
    TransportAPI
      .getMonths(pid)
      .then(months => {
        AppDispatcher.dispatch({
          actionType: TransportConstants.RECIEVE_MONTHS,
          months: months
        })
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: TransportConstants.RECIEVE_MONTHS_ERROR,
          message: message
        })
      })
  },

  getTransports: (pid, year, month) => {
    TransportAPI
      .getTransports(pid, year, month)
      .then(month => {
        AppDispatcher.dispatch({
          actionType: TransportConstants.RECIEVE_TRANSPORTS,
          month: month
        })
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: TransportConstants.RECIEVE_TRANSPORTS_ERROR,
          message: message
        })
      })
  }

}



// WEBPACK FOOTER //
// ./src/actions/TransportActions.js